import { UnwrapRef, reactive } from '@vue/composition-api';
import { createContext } from '@berlin-front/common/composables/context';

type UseLoadingContextType = UnwrapRef<{
  useLoading: () => {
    onComplete: () => void;
    isLoading: boolean;
    isCompleted: boolean;
    title: string;
    duration: number;
  };
}>;

export const LoadingContext = createContext<UseLoadingContextType>(() => ({
  useLoading: () =>
    reactive({
      title: '',
      duration: 1000,
      isCompleted: false,
      isLoading: true,
      onComplete: () => {},
    }),
}));
